export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50/70">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="inline-block text-xl md:text-2xl font-heading font-bold text-background-50 mb-4">
              51吃瓜网址
            </a>
            <p className="text-xs md:text-sm leading-relaxed text-background-50/60 max-w-[280px]">
              全网最全的51今日吃瓜与51吃瓜最新资讯平台，每日更新娱乐八卦、实时爆料与热门排行，满足全天候吃瓜需求。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              <li><a href="#carousel" className="text-xs md:text-sm text-background-50/60 hover:text-primary-400 transition-colors">焦点吃瓜</a></li>
              <li><a href="#faq" className="text-xs md:text-sm text-background-50/60 hover:text-primary-400 transition-colors">吃瓜问答</a></li>
              <li><a href="#ranking" className="text-xs md:text-sm text-background-50/60 hover:text-primary-400 transition-colors">吃瓜热榜</a></li>
              <li><a href="#updates" className="text-xs md:text-sm text-background-50/60 hover:text-primary-400 transition-colors">实时快讯</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4">热门栏目</h3>
            <ul className="space-y-2.5">
              <li><a href="#index" className="text-xs md:text-sm text-background-50/60 hover:text-primary-400 transition-colors">吃瓜索引</a></li>
              <li><a href="#cards" className="text-xs md:text-sm text-background-50/60 hover:text-primary-400 transition-colors">吃瓜速递</a></li>
              <li><a href="#topics" className="text-xs md:text-sm text-background-50/60 hover:text-primary-400 transition-colors">热门话题</a></li>
              <li><a href="#media" className="text-xs md:text-sm text-background-50/60 hover:text-primary-400 transition-colors">吃瓜视频</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-xs text-background-50/40 leading-relaxed">
              更多合作伙伴信息持续更新中，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 51吃瓜网址 · 51今日吃瓜 · 51吃瓜最新 · 51每日吃瓜速递
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span>51吃瓜网今日吃瓜</span>
            <span>|</span>
            <span>51吃瓜大赛</span>
          </div>
        </div>
      </div>
    </footer>
  );
}